
export class DecodeToken {
    constructor(
        public Token: string,
        public sessionId: string,
        public poliza: string,
        public dealerCode: string,
        public certificado: string,
        public RFC: string,
    ){}
}
